import { computed } from 'nanostores';
import { FormStepStore } from '../stores/form-step-store';
import { TooltipDetail } from '../../tooltip';

export function initProgressBar(progressBar: HTMLElement, { history, gotoStep }: FormStepStore) {
  const progressLine = progressBar.querySelector('.progress') as HTMLElement;
  const progressSteps = progressBar.querySelectorAll<HTMLElement>('.progress-step, .progress-item');

  const progressState = computed(history, history => ({ done: history.slice(0, -1), active: history.slice(-1)[0] }));

  const handleProgressStepClick = (index: number) => {
    const { done } = progressState.get();
    const entry = done.find(entry => entry.order === index);
    if (!entry) {
      return;
    }
    gotoStep(entry.id);
  };

  progressSteps.forEach((progressStep, index) => {
    progressStep.addEventListener('click', () => handleProgressStepClick(index));
  });

  progressState.subscribe($progressState => {
    const { done, active } = $progressState;

    //hide progressbar on result slides
    if (!progressSteps[active.order]) {
      progressBar.classList.add('fade-out');
      setTimeout(() => {
        progressBar.classList.add('is-hidden');
      }, 600);
      return;
    }

    //animate progress steps
    progressSteps.forEach((progressStep, index) => {
      const tooltipEntry = done.find(entry => entry.order === index);

      const updateEvent = new CustomEvent<TooltipDetail>('update-tooltip', {
        detail: {
          content: tooltipEntry?.title || '',
          enabled: tooltipEntry !== undefined
        }
      });

      // @ts-ignore
      if (!progressStep._tippy) {
        // waiting for tippy to be initialized to prevent race condition
        progressStep.addEventListener(
          'tooltip-init',
          () => {
            progressStep.dispatchEvent(updateEvent);
          },
          { once: true }
        );
      } else {
        progressStep.dispatchEvent(updateEvent);
      }

      progressStep.classList.toggle('progress-done', done.map(entry => entry.order).includes(index));
      progressStep.classList.toggle('progress-active', active.order === index);
      progressStep.classList.remove('progress-load');
    });

    //animate progress bar
    if (progressLine) {
      progressLine.style.width = `${(active.order / (progressSteps.length - 1)) * 100}%`;
    }
  });
}
